var React = require('react');

function CircleIconCheckInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#0A9E50","key":0}),React.createElement("path",{"d":"M22.5 31.25C27.3125 31.25 31.25 27.3125 31.25 22.5C31.25 17.6875 27.3125 13.75 22.5 13.75C17.6875 13.75 13.75 17.6875 13.75 22.5C13.75 27.3125 17.6875 31.25 22.5 31.25Z","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18.7812 22.5002L21.2575 24.9764L26.2188 20.0239","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CircleIconCheckInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"};

module.exports = CircleIconCheckInline;

CircleIconCheckInline.default = CircleIconCheckInline;
